angular.module('all').config(['$urlRouterProvider', '$urlServiceProvider', 'AppRoutesProvider',
    function ($urlRouterProvider, $urlServiceProvider, AppRoutesProvider) {

        'use strict';

        var appRoutes = AppRoutesProvider.getAppRoutes();

        $urlRouterProvider
            .when('', appRoutes.login.route)
            .when('/', appRoutes.login.route);

        $urlServiceProvider.deferIntercept();
    }
]
);
